import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../store/actions";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Box,
  Typography,
  CircularProgress,
  Tooltip
} from '@mui/material';
import EnhancedTableHead from "../../../UI/MaterialTableOverrides/EnhancedTableHead";
import TableTitle from '../../../UI/MaterialTableOverrides/TableTitle';
import IconButton from "@mui/material/IconButton";
import { Visibility, Delete, VisibilityOff } from "@mui/icons-material";

type IApiKey = {
  key: string,
  lastUsedDate: Date | null,
  createdAt: Date,
  _id: string,
}

export default function TenantApiKeys() {
  const dispatch = useDispatch();

  const [visibility, setVisibility] = useState<{[key:string]: boolean}>({});

  const tenant = useSelector((state: any) => state.tenants.tenant);
  const loadingTenant = useSelector((state: any) => state.tenants.loading);
  const loadingCreateDeleteApi = useSelector((state: any) => state.tenants.loadingCreateDeleteApiKey);

  const loading = loadingTenant || loadingCreateDeleteApi;

  const headRows = [
    { id: "key", numeric: false, disablePadding: false, label: "API Key" },
    { id: "lastUsedDate", numeric: false, disablePadding: false, label: "Último uso" },
  ];

  const apiKeys: IApiKey[] = tenant.tenantAPIKeys || [];

  useEffect(() => {
    const newVisibility: {[key:string]: boolean} = {};
    apiKeys.forEach((key) => {
      newVisibility[key._id] = false;
    })
    setVisibility(newVisibility);
  }, [apiKeys.length]);


  const addNewApiKey = () => {
    dispatch(actions.createApiKey(tenant._id));
  }

  const removeApiKey = (apiKeyId: string) => {
    dispatch(actions.deleteApiKey(tenant._id, apiKeyId))
  }


  const styles = {
    table: {
      position: 'relative',
    },
    opacityContainer: {
      opacity: loading ? '0.3' : '1',
    },
    spinner: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      top: '-5px',
      opacity: '1',
      zIndex: 2,
    },
    noResults: {
      height: '100px',
    },
    deleteTextConfirm: {
      marginLeft: '-30px',
      fontWeight: 'bold',
    },
    editWidth: {
      width: '90%'
    }
  }

  return (
    <>
      <Paper sx={{marginTop: '10px'}}>
        <TableTitle
          title='API Keys'
          addRow={() => addNewApiKey()}
        />
        <Table sx={styles.table}>
          <tbody>
            <tr>
              <td>
                {loading &&
                  <Box sx={styles.spinner}>
                    <CircularProgress />
                  </Box>}
                {(apiKeys.length === 0) &&
                  <Box sx={styles.noResults}>
                    {!loading && <Typography sx={styles.spinner}>Nenhum resultado encontrado</Typography>}
                  </Box>}
              </td>
            </tr>
          </tbody>
          <EnhancedTableHead
            headRows={headRows}
            order={''}
            orderBy={''}
            onRequestSort={() => {}}
          />
          <TableBody style={styles.opacityContainer}>
            {apiKeys.length > 0 && apiKeys.map((apiKey) => (
              <TableRow key={apiKey._id}>
                <TableCell >
                  <Box sx={{display: 'flex', alignItems: 'center'}}>
                    <Typography>{visibility[apiKey._id] ? apiKey.key : '*******************'}</Typography>
                    <IconButton onClick={() => setVisibility((prevState) => ({
                      ...prevState,
                      [apiKey._id]: !visibility[apiKey._id]
                    }))}>
                      <Tooltip title={visibility[apiKey._id] ? 'Visualizar' : 'Ocultar'}>
                        {visibility[apiKey._id] ? <VisibilityOff /> : <Visibility />}
                      </Tooltip>
                    </IconButton>
                  </Box>
                </TableCell>
                <TableCell >
                  <Box sx={{display: 'flex', alignItems: 'center'}}>
                    <Typography>{apiKey.lastUsedDate ? new Date(apiKey.lastUsedDate).toLocaleDateString('pt-BR') : 'Não utilizado'}</Typography>
                    <IconButton onClick={() => removeApiKey(apiKey._id)}>
                      <Tooltip title="Deletar">
                        <Delete />
                      </Tooltip>
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </>
  );

}



